import {
  Box,
  Skeleton,
  SliceSelectCard,
  SuspenseImage,
  Text,
} from "@prismicio/editor-ui"
import { Fragment, Suspense } from "react"

import type { SliceConfigWithSharedSlice } from "../sliceTableData"

interface Props {
  disabled: boolean
  slices: SliceConfigWithSharedSlice[]
  onSelectSlice: (slice: SliceConfigWithSharedSlice) => void
}

export function SlicePicker(props: Props) {
  const { disabled, slices, onSelectSlice } = props
  return (
    <Box
      overflow="hidden"
      flexDirection="column"
      gap={16}
      border={{ right: true, left: true }}
    >
      <Box flexDirection="column" padding={{ top: 12, inline: 24 }}>
        <Text variant="h3" color="grey12">
          Select a slice
        </Text>
      </Box>
      <SliceList
        disabled={disabled}
        slices={slices}
        onSelectSlice={onSelectSlice}
      />
    </Box>
  )
}

function SliceList(props: Props) {
  const { disabled, slices, onSelectSlice } = props
  return (
    <Box
      overflowY="auto"
      padding={{ bottom: 12, inline: 24 }}
      flexGrow={1}
      flexDirection="column"
      gap={16}
    >
      {slices.map((slice) => (
        <Fragment key={slice.sliceConfig.id}>
          <Text variant="h4">{slice.sliceConfig.name}</Text>
          {slice.sliceConfig.variations.map((variation) => (
            <SliceSelectCard
              key={slice.sliceConfig.id + variation.id}
              label={slice.sliceConfig.name}
              variation={variation.name}
              disabled={disabled}
              onClick={() =>
                onSelectSlice({
                  ...slice,
                  sliceVariation: variation.id,
                })
              }
            >
              <Suspense
                fallback={
                  <Skeleton
                    color="grey1"
                    borderRadius={4}
                    height={100}
                    width="80%"
                  />
                }
              >
                <SuspenseImage
                  src={variation.imageUrl}
                  alt={variation.description}
                  sizing="contain"
                  boxShadow="3"
                />
              </Suspense>
            </SliceSelectCard>
          ))}
        </Fragment>
      ))}
    </Box>
  )
}
